import { AuthenticationDetails, CognitoUserPool, CognitoUser } from 'amazon-cognito-identity-js';

let mockedAuthentication = 0;

const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';

const poolData = {
    UserPoolId: 'eu-central-1_Z1fSUQJcC',
    ClientId: '1cpp1vrhvogpjm5embddlb4ssr'
};

const getUserPool = () => new CognitoUserPool(poolData);

const getCurrentUser = () => getUserPool().getCurrentUser();

const isDevConfig = () => (process.env.CONFIG_ENV === 'dev' || process.env.CONFIG_ENV === 'sanity');

const isDevMode = () => (isDevConfig() && mockedAuthentication === 1);

const getSession = () => new Promise((resolve, reject) => {
  const currentUser = getCurrentUser();

  if (!currentUser) {
      reject();
        return;
    }

    currentUser.getSession((err, session) => {
        if (err) {
            reject(err);
            return;
        }

        resolve({
            currentUser,
            session
        });
    });
});

const getAccessToken = () => {
    if (isDevMode()) {
        return Promise.resolve(true);
    }
    return getSession().then(({ session }) => session.getAccessToken().getJwtToken());
};

const getIdToken = () => getSession().then(({ session }) => session.getIdToken().getJwtToken());

const getRefreshToken = () => getSession().then(({ session }) => session.getRefreshToken());

const getUsername = () => {
    if (isDevMode()) {
        return 'testuser';
    }
    const currentUser = getCurrentUser();
    return currentUser ? currentUser.getUsername() : null;
};

const getUserAttributes = () => getSession().then(
        ({ currentUser }) => new Promise((resolve, reject) => {
            currentUser.getUserAttributes((err, attributes) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(attributes);
            });
        })
    );

const getUserId = () =>	getUserAttributes()
    .then(attributes => {
        const attribute = _.find(attributes, ['Name', 'sub']);
        return _.get(attribute, 'Value');
    });

/**
 * User authentication
 *
 * @param {String} username
 * @param {String} password
 * @returns {Promise<any>}
 */
const authenticate = (username, password) => new Promise((resolve, reject) => {
    const authenticationDetails = new AuthenticationDetails({
        Username: username,
        Password: password
    });

    const cognitoUser = new CognitoUser({
        Username: username,
        Pool: getUserPool()
    });

    if (isDevConfig()) {
        console.log('Development, not using cognito. Succesful login.');
        mockedAuthentication = 1;
        resolve({});
    } else {
        cognitoUser.authenticateUser(authenticationDetails, {
            newPasswordRequired: () => resolve(NEW_PASSWORD_REQUIRED),
            onSuccess: () => resolve(),
            onFailure: err => reject(err)
        });
    }
});

const updatePassword = (username, password, newPassword) =>	new Promise((resolve, reject) => {
    const authenticationDetails = new AuthenticationDetails({
        Username: username,
        Password: password
    });

    const cognitoUser = new CognitoUser({
        Username: username,
        Pool: getUserPool()
    });

    cognitoUser.authenticateUser(authenticationDetails, {
        newPasswordRequired: (userAttributes, requiredAttributes) => {
            cognitoUser.completeNewPasswordChallenge(newPassword, requiredAttributes, {
                onSuccess: () => resolve(),
                onFailure: err => reject(err)
            });
        },
        onSuccess: () => resolve(),
        onFailure: err => reject(err)
    });
});

/**
 * Check if user is already authenticated
 *
 * @returns {Promise<any>}
 */
const isLoggedIn = () => {
    if (isDevMode()) {
        return Promise.resolve(true);
    }
    return getSession().then(({ session }) => session.isValid());
};

/**
 * User log-out
 */
const logOut = () => {
    mockedAuthentication = 0;
    const currentUser = getCurrentUser();
    if (currentUser) {
        currentUser.signOut();
    }
};

export default {
    NEW_PASSWORD_REQUIRED,
    authenticate,
    isLoggedIn,
    logOut,
    getUsername,
    getAccessToken,
    getIdToken,
    getRefreshToken,
    getUserId,
    updatePassword
};
